import React from 'react'
import { X } from 'lucide-react'

import { Popover, PopoverContent, PopoverTrigger } from '@rewardops/ui'

interface LimitExceededModalProps {
  className?: string
  shouldTrigger: boolean
  onClose: () => void
  children: React.ReactNode
  asChild?: boolean
  limitExceededMessage: string
}

const LimitExceededModal: React.FC<LimitExceededModalProps> = ({
  shouldTrigger,
  onClose,
  children,
  asChild = false,
  limitExceededMessage,
}) => {
  return (
    <Popover open={shouldTrigger} onOpenChange={(open) => !open && onClose()}>
      <PopoverTrigger
        {...(asChild ? { asChild } : {})}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </PopoverTrigger>
      <PopoverContent
        className="w-[324px] rounded-md border border-blue-500 bg-blue-50 p-6 shadow-[0_2px_6.7px_0_rgba(0,0,0,0.15)] backdrop-blur-none md:w-[500px]"
        sideOffset={5}
      >
        <div className="flex gap-4 md:gap-2">
          <div className="text-sm text-zinc-900">{limitExceededMessage}</div>
          <div>
            <X
              className="hover:cursor-pointer"
              onClick={() => onClose()}
              id="cart-limit-exceeded-modal-close"
            />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default LimitExceededModal
